import { render, staticRenderFns } from "./step.vue?vue&type=template&id=ebe96e10&scoped=true&"
import script from "./step.vue?vue&type=script&lang=ts&"
export * from "./step.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe96e10",
  null
  
)

export default component.exports